// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { rem } from '../../tokens/conversions';
import { skeletonColors } from './skeletonColors';
export var Skeleton = function(mode) {
    var c = skeletonColors(mode);
    var override = {
        MuiSkeleton: {
            defaultProps: {
                animation: 'wave'
            },
            styleOverrides: {
                root: {
                    backgroundColor: c.background,
                    borderRadius: rem(2)
                }
            }
        }
    };
    return override;
};

//# sourceMappingURL=Skeleton.js.map